module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/first.js
// module id = 1174
// module chunks = 0 15 16